import Krest from "~/assets/img/svg/krest.png";
import Galka from "~/assets/img/svg/galka.png";

/**
 * Маппинг tableIndex (PascalCase из GraphQL) → rowType (lowercase для permissions)
 * Используется каждой строкой таблицы, чтобы узнать свой тип независимо от URL.
 */
export const TABLE_INDEX_TO_ROW_TYPE: Record<string, string> = {
  Services: "services",
  Places: "places",
  PlacePosts: "placePosts",
  Warehouses: "warehouses",
  Tools: "tools",
  RequiredTools: "requiredTools",
  Personal: "personal",
  ToolsInsurance: "toolsInsurance",
  ToolsMetrological: "toolsMetrological",
  Notes: "notes",
  TradePremises: "tradePremises",
};

/**
 * Получить rowType строки из tableIndex.
 * Если tableIndex не найден — возвращает null.
 */
export function getRowTypeFromTableIndex(tableIndex?: string): string | null {
  if (!tableIndex) return null;
  return TABLE_INDEX_TO_ROW_TYPE[tableIndex] ?? null;
}

export const ROW_CHECK_OPTIONS_SELECT = [
  "Fact",
  // "FactContract",
  // "Combine",
  // "PlacesCombine",
];

export const ROW_CHECK_OPTIONS_DATE = [
  "PositionStart",
  "planToFixAt",
  "StudyCertificateDate",
  "CheckedDate",
];

export const ROW_CHECK_OPTIONS_FLOAT = ["Area", "Total"];

export const ROW_CHECK_OPTIONS_INPUT = [
  {
    name: "CertificationDate",
    type: "text",
  },
  // "CheckedDate",
  {
    name: "Model",
    type: "text",
  },
  {
    name: "Total",
    type: "number",
  },
  // {
  //   name: "Standard",
  //   type: "text",
  // },
  {
    name: "Position",
    type: "text",
  },
  {
    name: "PersonName",
    type: "text",
  },
  // {
  //   name: "Combine",
  //   type: "number",
  // },
  {
    name: "Area",
    type: "number",
  },
  {
    name: "Note",
    type: "text",
  },
  {
    name: "Year",
    type: "number",
  },
  {
    name: "Country",
    type: "text",
  },
  {
    name: "Address",
    type: "text",
  },
  {
    name: "fixExplanation",
    type: "text",
  },
  {
    name: "responsiblePersonContact",
    type: "text",
  },
];

export const CHECK_OPTIONS = [
  {
    value: 1,
    label: "provided",
    icon: Galka,
  },
  {
    value: 0,
    label: "not_provided",
    icon: Krest,
  },
];

export const CHECK_OPTIONS_COMPLIANCE = [
  {
    value: 1,
    label: "corresponds",
    icon: Galka,
  },
  {
    value: 0,
    label: "does_not_match",
    icon: Krest,
  },
];

export const CHECK_OPTIONS_IS_RESOLVE = [
  {
    value: true,
    label: "corrected",
    icon: Galka,
  },
  {
    value: false,
    label: "not_fixed",
    icon: Krest,
  },
];

export const CHECK_OPTIONS_IS_OUTSOURCING = [
  {
    value: 1,
    label: "autsors",
    icon: Galka,
  },
  {
    value: 0,
    label: "not_autsor",
    icon: Krest,
  },
];
